const currencyComposition = props => {
  const { $store: store } = useNuxtApp()
  const allRegions = computed(() => store.getters['region/allRegions'])

  const getRegionCurrencyID = regionID => {
    const nowRegion = allRegions.value.find(regionInfo => {
      return regionInfo.region_id === regionID
    })
    return nowRegion ? nowRegion.currency_id : 0
  }

  const getDownloadFeedBackByRegion = currencyId => {
    let feedbackText = ''
    // 幣別ID 0: 台幣, 1: 港幣, 2: 日幣, 3: 馬幣, 4: 泰銖
    switch (currencyId) {
      case 1:
        feedbackText = 'HKD 150'
        break
      case 2:
        feedbackText = 'JPY 1200'
        break
      case 3:
        feedbackText = 'MYR 60'
        break
      case 4:
        feedbackText = 'THB 300'
        break
      case 0:
      default:
        feedbackText = 'TWD 300'
        break
    }
    return feedbackText
  }

  return {
    getDownloadFeedBackByRegion,
    getRegionCurrencyID,
  }
}

export default currencyComposition
